import _ from 'lodash';

export default class WMICJurisdictionUtil {
    static isBaseState = (baseData, ...baseStateToCheck) =>
        baseStateToCheck.includes(_.get(baseData, 'baseState.value.code'));
}
